import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=26a7829e&scoped=true&"
import script from "./Instruction.vue?vue&type=script&lang=js&"
export * from "./Instruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a7829e",
  null
  
)

export default component.exports